
/**
 * `Stage` - The Stage of the page, also called Hero Section, is a large element that is pinned to the header section and usually has a prominent visual hierarchy because it is often the first thing users see when arriving on a website.
 * The simple stage can be active in two modes. First, the simple text stage. This is the less complex state where only a headline, text and an optional dealer-logo is displayed.
 * Second, the simple image stage. A far more content-rich mode where _additionally_ two CTA buttons, a background image, image-gradients and footnotes are featured.
 */
import { StageComponent } from './Stage';
import StageCtaButtons from './StageCtaButtons.vue';
import StageImage from './StageImage.vue';
import StagePrice from './StagePrice.vue';
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import Personalisation from '@owc-utils/Mixins/Personalisation';
import FeatureStageSlider from './FeatureSlider/FeatureStageSlider.vue';
import Footnotes from '@owc-packages/Footnotes/src/Footnotes.vue';
import { getFootnotesIfAvailable } from '@owc-utils/Footnotes/FootnotesUtils';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';

export default (ComponentInitializeDispatcher as StageComponent).extend({
  name: 'owc-stage',
  components: {
    StageCtaButtons,
    StageImage,
    StagePrice,
    FeatureStageSlider,
    Footnotes,
    ValidationBoxWrapper,
  },
  mixins: [OwcDataComponent, Personalisation],
  //  supports skeletons layout shifts of the web component
  mounted() {
    if (this.isBuildWc) {
      const host = (this.$el?.getRootNode() as ShadowRoot).host;
      const hostClass = this.isSimpleImageStage ? 'owc-image-stage-host' : 'owc-text-stage-host';
      host.classList.add(hostClass);
    }
  },
  computed: {
    // Makes sure that all API fields needed for the simple image stage mode are filled
    isSimpleImageStage: function() {
      return Boolean(this.personaliseableData?.stageImage);
    },
    hasCtaButtons() {
      return Array.isArray(this.personaliseableData?.buttons) && this.personaliseableData?.buttons.length > 0;
    },
    hasFeatureStageItems() {
      const { featuredItems } = this.personaliseableData;
      return featuredItems != null && featuredItems.length > 0;
    },
    retailLogo() {
      return this.personaliseableData?.retailLogo;
    },
    isDarkMode() {
      return Boolean(this.personaliseableData?.darkMode);
    },
    footnotes() {
      return getFootnotesIfAvailable(this.personaliseableData);
    },
  },
});
